// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__p-OE0","modal":"Modal_modal__J4dXB","slide-down":"Modal_slide-down__usQdI"};